import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { AccountManagementComponent } from "./account-management.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { WarningModalModule } from "../../lib/warning-modal/warning-modal.module";
import { DisplayOrgModule } from "../../components/display-org/display-org.module";
import { FooterModule } from 'src/app/components/footer/footer.module';
import { OrganisationAndBrandComponent } from "./organisation-and-brand/organisation-and-brand.component";
import { AiSettingsComponent } from './ai-settings/ai-settings.component'
import { OrgReferenceSettingsComponent } from './org-reference-settings/org-reference-settings.component';
import { LoaderModule } from "src/app/components/loader/loader.module";
import { PulseSettingsComponent } from './pulse-settings/pulse-settings.component';
import { OrgSettingsComponent } from './org-settings/org-settings.component';
import { GroupDropdownModule, TooltipModule, CardsModule, EmptyStateModule, DynamicGroupDropdownModule, ToggleModule, LozengeModule } from '@xref/xref-lib';
import { OrgUsersModule } from 'src/app/components/org-users/org-users.module';
import { ButtonModule, TagsModule, KebabMenuModule } from '@xref/xref-lib';
import { OrgTrustMarketplaceComponent } from './org-trust-marketplace/org-trust-marketplace.component';
import { OrgTrustMarketplaceHelpModalComponent } from './org-trust-marketplace/org-trust-marketplace-help-modal/org-trust-marketplace-help-modal.component';
import { TeamsSettingsComponent } from './teams-settings/teams-settings.component';
import {AppPaginationModule} from "../../components/pagination/pagination.module";
import { PermissionHelpComponent } from './permission-help/permission-help.component';
import { RequestTemplateComponent } from './request-template/request-template.component';
import {
  OrgUserProfileModalModule
} from "../../components/org-users/components/org-user-profile-modal/org-user-profile-modal.module";
import { TemplateConfirmationModalModule } from '../../components/template-confirmation-modal/template-confirmation-modal.module';
import { TemplateRenameModalModule } from '../../components/template-rename-modal/template-rename-modal.module';
import { InputsModule } from '@xref/xref-lib';

@NgModule({ declarations: [
        AccountManagementComponent,
        OrganisationAndBrandComponent,
        AiSettingsComponent,
        OrgReferenceSettingsComponent,
        PulseSettingsComponent,
        OrgSettingsComponent,
        OrgTrustMarketplaceComponent,
        OrgTrustMarketplaceHelpModalComponent,
        TeamsSettingsComponent,
        PermissionHelpComponent,
        RequestTemplateComponent
    ], imports: [BrowserModule,
        CommonModule,
        FormsModule,
        ModalModule,
        WarningModalModule,
        DisplayOrgModule,
        FooterModule,
        LoaderModule,
        TooltipModule,
        OrgUsersModule,
        ButtonModule,
        GroupDropdownModule,
        CardsModule,
        KebabMenuModule,
        AppPaginationModule,
        TagsModule,
        ToggleModule,
        EmptyStateModule,
        LozengeModule,
        OrgUserProfileModalModule,
        DynamicGroupDropdownModule,
        TemplateConfirmationModalModule,
        TemplateRenameModalModule,
        InputsModule,
    ], providers: [
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AccountManagementModule {
}
